/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import { TrainLanding } from "@pushpress/shared-components";
import { useParams } from "react-router-dom";
import { env } from "../../../env";
import { isUserSuperuser } from "../../../utils/session";
import Dashboard from "../../../layouts/Dashboard";
import {
  fetchAppDetails,
  fetchInstalledApps,
  installApp,
  uninstallApp,
} from "../../../redux/actions/appActions";
import { createNewChatWithPrePopulatedMessage } from "../../../utils/Intercom";

export default (props) => {
  const [app, setApp] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const { id } = useParams();
  const clientId = props.client.uuid;
  const isSuperuser = isUserSuperuser(props.user);

  const [installId, setInstallId] = useState();

  if (!clientId) return <div>Loading...</div>;

  useEffect(() => {
    fetchInstalledApps(clientId).then((response) => {
      const installed = response.data.map((i) => {
        if (i.status === "INSTALLED" && i.appId === id) {
          setInstallId(i.id === undefined ? null : i.id);
          return i.appId;
        }
        return `Install Error ${i.appId}`;
      });
      const isAppInstalled = installed.includes(id);
      setIsInstalled(isAppInstalled);
    });
  }, []);

  useEffect(() => {
    fetchAppDetails(id).then((response) => {
      if (
        response.data &&
        response.data.installationWebhookUrl &&
        response.data.beta
      ) {
        const redirectLink = response.data.placeholderUrl;
        if (props && props.user && props.user.superuser === 1) {
          response.data = {
            ...response.data,
            installationWebhookUrl: response.data.installationWebhookUrl,
          };
        } else {
          response.data = {
            ...response.data,
            installationWebhookUrl: redirectLink,
            redirectLink: true,
          };
        }
      }

      setApp(response.data);
    });
  }, []);

  const onClickInstall = (done) => {
    if (app.redirectLink) {
      window.location.href = app.installationWebhookUrl;
    } else {
      installApp(clientId, id, () => {
        setIsInstalled(true);
        done();
      });
    }
  };

  const onClickUninstall = async () => {
    setIsInstalled(false);
    if (isSuperuser) {
      await uninstallApp(clientId, installId, () => {
        window.location.href = "/";
      });
    } else {
      createNewChatWithPrePopulatedMessage("intercom.deactivateTrain");
    }
  };

  const onClickAskQuestion = () => createNewChatWithPrePopulatedMessage("");

  return (
    <Dashboard>
      {app ? (
        <div className="app-configuration-grid">
          <TrainLanding
            onClickInstall={onClickInstall}
            onClickUninstall={onClickUninstall}
            onClickAskQuestion={onClickAskQuestion}
            isInstalled={isInstalled}
            isUserAdmin={isSuperuser}
            imageProperties={{
              url: "https://pushpresscdn.s3.amazonaws.com/integrations/cards/train-banner.png",
            }}
            prices={{ price: 36, setupFee: 0 }}
            trainAppContainerImage={{
              url: "https://pushpresscdn.s3.amazonaws.com/integrations/cards/train-card.png",
            }}
            iOsAppLink={env.TRAIN_IOS_APP_LINK}
            androidAppLink={env.TRAIN_ANDROID_APP_LINK}
            learnMoreLink={env.TRAIN_LEARN_MORE_LINK}
          />
        </div>
      ) : (
        <div>Loading app...</div>
      )}
    </Dashboard>
  );
};
